export const Plans = Object.freeze({
  ONE_MONTH: 'ONE_MONTH',
  SIX_MONTH: 'SIX_MONTH',
  FREE_TIER: 'FREE_TIER',
});
